import React, { Component } from "react";
import MoneyCard from "../common/Money-card";
import { Router, Route, NavLink, Redirect } from "react-router-dom";
import { createBrowserHistory } from "history";
import Transactions from "./Transactions";
import Payouts from "./Payouts";
import { StatsContext } from "../contexts/StatsContext";
import API from "../common/Api";
import { connect } from "react-redux";

const history = createBrowserHistory();
const mapStateToProps = (state) => ({
  headers: { headers: state.headers() }
})

export default connect(mapStateToProps)((class Payment extends Component {
  static contextType = StatsContext;
  state = {
    redirect: false,
  };
  redirect = () => {
    if (this.props.location.pathname === "/payments") {
      this.setState({ redirect: "/payments/transactions" });
    }
  };
  getTransactions = () => {
    API.get("business/transactions", this.props.headers).then(({ data: { data } }) => {
      this.setState({ payment: data })
    })
  }
  componentDidMount = () => {
    //always show transactions as default
    this.redirect();
    this.getTransactions()
  };

  render() {
    const { stats } = this.context;

    return (
      stats ?
        <div className="all-payments">
          <div className=" bookings section">
            <div className="wrapper section-header flex space-btw">
              <p className="section-title">Payments</p>
              {/* <div className="co-pink link">See all bookings</div> */}
            </div>
            <div className="cash-container">
              <div className="money-cards">
                <MoneyCard title="Total Made" value={`₦${stats.total_made}`} />
                <MoneyCard
                  title="Bookings"
                  value={`${stats.number_of_bookings}`}
                />
                <MoneyCard title="Pending payout" value={`₦${stats.wallet_balance}`} />
              </div>
            </div>



            <Router history={history}>
              {this.state.redirect ? (
                <Redirect to={{ pathname: this.state.redirect }} />
              ) : (
                  null
                )}

              <div className="wrapper mini-route">
                <div className="mini-navigation flex">
                  <NavLink exact
                    to={{ pathname: "/business/payments" }}
                    className="card"
                  >
                    Transactions
                </NavLink>
                  <NavLink exact
                    to={{ pathname: "/business/payments/payouts" }}
                    className="card"
                  >
                    Payouts
                </NavLink>
                </div>

                <div className="mini-app card">
                  <Route
                    exact
                    path="/business/payments"
                    component={() => <Transactions payments={this.state.payment} />}
                  />
                  <Route exact path="/business/payments/payouts" component={() => <Payouts payments={this.state.payment} />} />
                </div>
              </div>
            </Router>
          </div>
        </div>
        : null
    );
  }
}))
